import CyrillicToTranslit from 'cyrillic-to-translit-js'
import { injectable } from 'inversify'

@injectable()
export class Translit {
  protected transliterator: ReturnType<typeof CyrillicToTranslit>

  constructor() {
    this.transliterator = CyrillicToTranslit({ preset: 'ru' })
  }

  transform(input: string, spaceReplacement: string = '-') {
    return this.transliterator.transform(input, spaceReplacement)
  }
}
